import request from "@/untils/request.js"

export const getAllFinanceclass = (params) => {
    return request.get("/outpatient/financeclass/search", {params})
}

export const addFinanceclass = (data) => {
    return request.post("/outpatient/financeclass", data)
}

export const editFinanceclass = (data) => {
    return request.put("/outpatient/financeclass", data)
}


export const getFinanceclassList = (params) => {
    return request.get("/outpatient/financeclass/list", {params})
}

export const getFundList = (params) => {
    return request.get("/outpatient/docclinic/fundList", {params})
}

export const addFundInitial = (data) => {
    return request.post("/outpatient/docclinic/fundInitial", data)
}
